//
// Module for the Fund Employer Reporting Batch Notices Index view
//
rs.module("content/fund/account/employerreportingbatchnotices/index",

    [
        "common/select-helper",
        "controls/components/event-banner"
    ],

    function (selectHelper, eventBanner) {

        var _executeSelectionChanged;

        // Initialize the module
        function initialize(jsSelectors, backendUrl, grid, selectionLimit, defaultFromDate) {

            // Unpack filter js selectors
            var formFilter = $.js(jsSelectors.formFilter);

            var employerSelect = formFilter.js(jsSelectors.employerSelect);
            var employerSelectHidden = formFilter.js(jsSelectors.employerSelectHidden);
            var batchNumberSelect = formFilter.js(jsSelectors.batchNumberSelect);
            var workingBatchSelect = formFilter.js(jsSelectors.workingBatchSelect);
            var loadingSpinner = formFilter.js(jsSelectors.loadingSpinner);
            var fromDateInput = formFilter.js(jsSelectors.fromDateInput);
            var toDateInput = formFilter.js(jsSelectors.toDateInput);

            // Unpack form js selectors
            var form = $.js(jsSelectors.form);

            var deleteButton = form.js(jsSelectors.deleteButton);

            // Get select helper(s) for drop down properties
            var employerSelectHelper = selectHelper.getHelper(employerSelect);
            var batchNumberSelectHelper = selectHelper.getHelper(batchNumberSelect);
            var workingBatchSelectHelper = selectHelper.getHelper(workingBatchSelect);

            // On Batch Select change, enable/disable the working batch select
            batchNumberSelect.change(function () {
                var selectedBatch = batchNumberSelect.val();
                workingBatchSelectHelper.setDisabled(selectedBatch != '');
            });

            // On Working Batch Select change, enable/disable the batch select
            workingBatchSelect.change(function () {
                var selectedBatch = workingBatchSelect.val();
                batchNumberSelectHelper.setDisabled(selectedBatch != '');
                employerSelectHelper.setDisabled(selectedBatch != '');

                if (selectedBatch != '') {
                    var workingBatchKeys = selectedBatch.split(",");
                    var employerKey = workingBatchKeys[1];
                    if (employerSelect.val() != employerKey) {
                        if (!fromDateInput.val() && !toDateInput.val()) {
                            fromDateInput.val(defaultFromDate);
                        }
                    }
                    employerSelectHelper.setValue(employerKey);
                    employerSelectHidden.val(employerKey);
                }
            });

            // On Employer Select change, reload the Batch Number drop down
            employerSelect.change(function () {

                loadingSpinner.show();

                // Re-retrieve batchNumberSelect
                batchNumberSelectHelper.loadOptionsFrom(backendUrl, { employerKey: employerSelect.val() }, { withBlank: true });

                batchNumberSelectHelper.setDisabled(false);
                workingBatchSelectHelper.setDisabled(false);

                // On employer change - if date inputs cleared, reset to default date filter
                if (!fromDateInput.val() && !toDateInput.val()) {
                    fromDateInput.val(defaultFromDate);
                }

                loadingSpinner.hide();
            });

            // Enforce ValueCountLimit on grid deletion.
            // i.e. Since we can't send more than records than what is defined by the supplied selection limit on the post action, disable delete above that number.
            grid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged) {

                    // If greater than the supplied selection limit, disable delete and add event message.
                    if (grid.selectedValues.length >= selectionLimit) {
                        eventBanner.addErrorMessages("Up to " + $.format.number(selectionLimit, "#,##0") + " records may be selected to delete at one time.");
                        deleteButton.setDisabled();
                    }
                    else {
                        eventBanner.removeErrorMessages();
                        deleteButton.setDisabled(false);
                    }
                }

                _executeSelectionChanged = true;
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);